import { render, staticRenderFns } from "./SdsDateField.vue?vue&type=template&id=5cb6f4bf"
import script from "./SdsDateField.vue?vue&type=script&setup=true&lang=ts"
export * from "./SdsDateField.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports